// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a917bb05","453":"25b42e10"}[chunkId] + ".chunk.js";
};